function CardEspacoLux() {
    return (
        <div className="card-container">
            <div className='text-block'>
                <h1 className='piso-name'>Luminária</h1>
                <div className='garantia'>
                    <span>Período de Garantia Residencial</span>
                    <div className='garantia-info'>
                        <h1 className='garantia-numero'>3</h1>
                        <span className='garantia-meses'>meses</span>
                    </div>
                </div>
                <hr />
                <div className='garantia'>
                    <span>Período de Garantia Comercial</span>
                    <div className='garantia-info'>
                        <h1 className='garantia-numero'>3</h1>
                        <span className='garantia-meses'>meses</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CardEspacoLux;